(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fec-site-header"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return

    const openMenus = document.querySelectorAll('.fec-site-header__menu[open]')
    openMenus.forEach((menu) => {
      menu.removeAttribute('open')
      menu.querySelector('summary')?.focus()
    })
  })
  } catch(e) { console.error(e); }
})();

})();
